import React from "react";
import InputSelect from "./InputSelect";

const InputSelectSearchable = (props) => <InputSelect {...props} isSearchable />;

export default InputSelectSearchable;
